import React from 'react';
import { useQuery } from 'react-query';
import api from '../../services/api';
import { PhoneCall } from 'lucide-react';

export default function RingGroupsPage() {
  const { data = [], isLoading } = useQuery('ring-groups', () => api.get('/ring-groups').then(r => r.data));
  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold text-white">Grupos de Timbrado</h1>
        <p className="text-gray-400 text-sm">{data.length} grupos configurados</p></div>
      {isLoading ? <div className="flex justify-center py-12"><div className="spinner" /></div> : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {data.map(g => (
            <div key={g.id} className="card">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-green-600/20 rounded-xl flex items-center justify-center">
                  <PhoneCall size={18} className="text-green-400" />
                </div>
                <div>
                  <div className="font-semibold text-white">{g.name}</div>
                  <div className="text-xs text-gray-400">Ext. {g.number} | {g.strategy} | {g.timeout}s</div>
                </div>
              </div>
              {g.members && (
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {g.members.map(m => (
                    <span key={m.id} className="badge-info">{m.number}</span>
                  ))}
                </div>
              )}
            </div>
          ))}
          {!data.length && <div className="card col-span-2 text-center py-12 text-muted">Sin grupos configurados</div>}
        </div>
      )}
    </div>
  );
}
